import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_get_serialnumber_by_various_top1Service {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licenseplateId?: number, locationId?: number, lotId?: number, materialId?: number, projectId?: number }): 
  Promise<{ result: { Id?: number, LicensePlateId?: number, LotId?: number } }> 
  {
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_various_top1/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
